import PasswordDefinitionExperience from "../components/PasswordDefinitionExperience";

export default function ResetPasswordPage() {
  return <PasswordDefinitionExperience mode="reset" />;
}